"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getClassNames = void 0;

var _react = require("@fluentui/react");

var getClassNames = (0, _react.memoizeFunction)(function (theme) {
  var semanticColors = theme.semanticColors;
  return {
    root: (0, _react.mergeStyles)({
      display: 'flex',
      fontSize: theme.fonts.large.fontSize,
      color: semanticColors.headerBrandText,
      fontWeight: _react.FontWeights.semibold,
      alignItems: 'center',
      padding: '0 20px',
      whiteSpace: 'nowrap',
      selectors: {
        '& a': {
          color: semanticColors.headerBrandText
        },
        '& a:hover': {
          color: semanticColors.headerBrandText
        },
        '& a:focus': {
          color: semanticColors.headerBrandText
        },
        '& i': {
          fontSize: theme.fonts.medium.fontSize,
          fontWeight: _react.FontWeights.semibold,
          color: semanticColors.headerBrandText
        }
      }
    })
  };
});
exports.getClassNames = getClassNames;